import { apiSlice } from '../../app/api/apiSlice'
import { generateFormatedURL } from "../urlFormatter";

const photoApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPhotoList: builder.query<any, any>({
            query: (args) => "/Photo".concat(generateFormatedURL(args)),
        }),
        getLatestPhotoList: builder.query<any, any>({
            query: (args) => "/Photo/Station/Latest".concat(generateFormatedURL(args)),
        }),
    })
})

export const {
    useLazyGetPhotoListQuery,
    useLazyGetLatestPhotoListQuery
} = photoApiSlice;